import { useState, useEffect } from "react";
import { Header, BottomNav } from "../components/Header";
import { ProductCard } from "../components/ProductCard";
import { useAuth, API } from "../App";
import axios from "axios";
import { Heart } from "lucide-react";

const FavoritesPage = () => {
  const { token } = useAuth();
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFavorites();
  }, []);

  const fetchFavorites = async () => {
    try {
      const response = await axios.get(`${API}/users/favorites`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true
      });
      setFavorites(response.data);
    } catch (error) {
      console.error("Error fetching favorites:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleLikeToggle = (productId, liked) => {
    if (!liked) {
      setFavorites(prev => prev.filter(p => p.product_id !== productId));
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAF9] pb-20 md:pb-8">
      <Header />

      <main className="max-w-[470px] mx-auto px-4 py-6">
        <h1 className="text-2xl font-bold text-[#0F172A] mb-6">Mis Favoritos</h1>

        {loading ? (
          <div className="flex justify-center py-12">
            <div className="spinner"></div>
          </div>
        ) : favorites.length === 0 ? (
          <div className="empty-state" data-testid="empty-favorites">
            <Heart size={64} />
            <h3 className="text-lg font-semibold text-[#0F172A] mt-4">No tienes favoritos</h3>
            <p className="text-sm text-[#64748B]">
              Dale like a productos para guardarlos aquí
            </p>
          </div>
        ) : (
          <div className="space-y-6" data-testid="favorites-feed">
            {favorites.map((product) => (
              <ProductCard 
                key={product.product_id} 
                product={product}
                onLikeToggle={handleLikeToggle}
              />
            ))}
          </div>
        )}
      </main>

      <BottomNav />
    </div>
  );
};

export default FavoritesPage;
